/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const contactResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const contactResponseOutputUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const contactResponseOutputDestinationMax = 254;

export const contactResponseOutputLabelMax = 80;

export const contactResponseOutputPriorityMax = 100;

export const contactResponseOutputVerifiedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const contactResponseOutputVerificationRequestedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const contactResponseOutputDestinationRevisionExclusiveMin = 0;
export const contactResponseOutputDestinationRevisionMax = 9007199254740991;

export const contactResponseOutputAvailableVerificationTransportsMax = 3;

export const contactResponseOutputVersionExclusiveMin = 0;
export const contactResponseOutputVersionMax = 9007199254740991;

export const contactResponseOutputCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const contactResponseOutputUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);

export const ContactResponseOutput = zod.object({
  id: zod.uuid().regex(contactResponseOutputIdRegExp),
  userId: zod.uuid().regex(contactResponseOutputUserIdRegExp),
  kind: zod.enum(['email', 'telephone']),
  destination: zod.string().min(1).max(contactResponseOutputDestinationMax),
  label: zod.string().min(1).max(contactResponseOutputLabelMax),
  priority: zod.int().min(1).max(contactResponseOutputPriorityMax),
  enabled: zod.boolean(),
  verifiedAt: zod.union([
    zod.iso.datetime({ offset: true }).regex(contactResponseOutputVerifiedAtOneRegExp),
    zod.null(),
  ]),
  verificationRequestedAt: zod
    .union([
      zod.iso
        .datetime({ offset: true })
        .regex(contactResponseOutputVerificationRequestedAtOneRegExp),
      zod.null(),
    ])
    .optional(),
  destinationRevision: zod
    .int()
    .gt(contactResponseOutputDestinationRevisionExclusiveMin)
    .max(contactResponseOutputDestinationRevisionMax),
  smsEnabled: zod.boolean(),
  voiceEnabled: zod.boolean(),
  availableVerificationTransports: zod
    .array(zod.enum(['email-link', 'sms-code', 'voice-code']))
    .max(contactResponseOutputAvailableVerificationTransportsMax)
    .optional(),
  version: zod
    .int()
    .gt(contactResponseOutputVersionExclusiveMin)
    .max(contactResponseOutputVersionMax),
  createdAt: zod.iso.datetime({ offset: true }).regex(contactResponseOutputCreatedAtRegExp),
  updatedAt: zod.iso.datetime({ offset: true }).regex(contactResponseOutputUpdatedAtRegExp),
});

export type ContactResponseOutput = zod.input<typeof ContactResponseOutput>;
export type ContactResponseOutputOutput = zod.output<typeof ContactResponseOutput>;
